export default __webpack_public_path__ + "static/media/phone_gray.5c1412ed.svg";